<template>
    <div class="container">
        <div class="w-100 d-flex justify-content-start">
            <ul class="nav nav-tabs w-100 nav-fill">
                <li class="nav-item" :class="{ copprofftabshadow: statsSection == 'synthetic' }"
                    @click.prevent="endleStatSectionChange('synthetic')">
                    <a class="nav-link" :class="{ active: statsSection == 'synthetic' }" style="font-size: 1.8rem;"
                        href="#">Données synthétiques</a>
                </li>
                <li class="nav-item" :class="{ copprofftabshadow: statsSection == 'fragile' }"
                    @click.prevent="endleStatSectionChange('fragile')">
                    <a class="nav-link" :class="{ active: statsSection == 'fragile' }" style="font-size: 1.8rem;"
                        href="#">Pré-repérage des fragilités (bêta)</a>
                </li>
            </ul>
        </div>
        <div>
            <CoproffStats v-if="statsSection == 'synthetic'" :section="section" :tag='tag' :dfperims='dfperims'
                :terrLevelSelected='terrLevelSelected' :terrCodeSelected='terrCodeSelected'
                :terrLabelSelected='terrLabelSelected' :millesime='millesime' />
            <CoproffStatsFragil v-else :section="section" :tag='tag' :dfperims='dfperims'
                :terrLevelSelected='terrLevelSelected' :terrCodeSelected='terrCodeSelected'
                :terrLabelSelected='terrLabelSelected' :millesime='millesime' />
        </div>
    </div>

</template>

<script>
import CoproffStats from './CoproffStats.vue';
import CoproffStatsFragil from './CoproffStatsFragil.vue';

export default {
    name: "coproff_stats_home",
    props: ['tag', 'dfperims', 'terrLevelSelected', 'terrCodeSelected', 'terrLabelSelected', 'millesime', 'section'],
    components: {
        CoproffStats,
        CoproffStatsFragil
    },
    data: function () {
        return {
            statsSection: 'synthetic'
        }
    },
    methods: {
        endleStatSectionChange: function (section) {
            this.statsSection = section;
        }
    }
};
</script>

<style scoped>
.coproff-csv-btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    border-radius: 3px;
    transition: background-color 0.15s ease-in-out;
}

.copprofftabshadow {
    box-shadow: black 1px -3px 6px -6px;
}
</style>
